import { Component, OnInit, inject, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FbPixelService } from '../../service/fb-pixel.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  showBanner = false;
  private platformId = inject(PLATFORM_ID);
  private fbPixelService = inject(FbPixelService);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const consent = localStorage.getItem('cookie-consent-granted');
      if (consent === null) {
        this.showBanner = true;
      } else if (consent === 'true') {
        this.fbPixelService.enableAfterConsent();
      }
    }
  }

  acceptAll(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('cookie-consent-granted', 'true');
      this.fbPixelService.enableAfterConsent();
      this.showBanner = false;
    }
  }

  rejectAll(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('cookie-consent-granted', 'false');
      // If already initialized, we can clean up
      this.fbPixelService.destroy();
      this.showBanner = false;
    }
  }
}
